import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Select, Typography } from "antd";
import { FormInstance } from "antd/lib";

import { FunctionComponent, useEffect, useState } from "react";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { KeyValue } from "../../../../../constants";
import { getCourseFilterUniversity } from "../../../../../service/statistical-report";
import { BankProps } from "../../../../../types/transaction";
import "./filter-group.scss";
import { viLocale as locale } from "../../../../../utils/pickerType";

type FormFilterProps = {
  handleCloseFilter: () => void;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  setFilterData: any;
  dataOptions?: any;
  filterData: any;
  check?: boolean,
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  form,
  showFilter,
  clearFilter,
  filterData,
  setFilterData,
  check,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const [courseOptions, setCourseOptions] = useState<KeyValue[]>([]);

  const handleFinish = (values: any) => {
    setFilterData(values)

  };

  useEffect(() => {
    const getCourses = async () => {
      const res = await getCourseFilterUniversity();
      setCourseOptions(
        res.data.data.map((item: BankProps) => ({
          label: item.name,
          value: item.id,
        }))
      );
    };
    getCourses();
  }, []);

  const paymentStatus = [
    {
      value: 0,
      label: t("Đang thanh toán", "Đang thanh toán")
    }, {
      value: 1,
      label: t("Thành công", "Thành công")
    }, {
      value: 2,
      label: t("Thất bại", "Thất bại")
    }
  ]
  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={handleFinish}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>
                {t("Tên khoá học", "Tên khoá học")}
              </Typography.Title>
              <Form.Item name="courseId">
                <FormItemDropdown placeholder={t("Chọn khoá học", "Chọn khoá học")}
                  options={courseOptions} disabled={check} />
              </Form.Item>

            </Col>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>
                {t("Trạng thái", "Trạng thái")}
              </Typography.Title>
              <Form.Item name="status">
                <Select placeholder={t("Trạng thái", "Trạng thái")}
                  options={paymentStatus}
                >
                </Select>
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày tạo", "Ngày tạo")}</Typography.Title>
              <Form.Item name="approvedDate">
                <RangePicker
                  placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                  format="YYYY-MM-DD"
                  value={filterData.approvedDate}
                  locale={locale}
                />
              </Form.Item>
            </Col>

            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={() => {
                    form.resetFields();
                    setFilterData({});
                  }}                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
